import getIconForFile, { FileIcon, getFileIconFromSprite } from './getIconForFile';
import getCDNIconUrl from './getCDNIconUrl';

// icons also present in getIconForFile:
const calendarFileIcon: FileIcon = getFileIconFromSprite('calendar');
const genericFileIcon: FileIcon = getFileIconFromSprite('generic');
const msgFileIcon: FileIcon = getFileIconFromSprite('email');

// Icons unique to attachments
const sharedFolderIcon: FileIcon = getFileIconFromSprite('sharedfolder');
const blockedFileIcon: FileIcon = {
    extraSmall: getFileIconFromSprite('generic').extraSmall,
    small: getFileIconFromSprite('generic').small,
    medium: getFileIconFromSprite('blockedfile').medium,
    large: getFileIconFromSprite('generic').large,
    cdn: getCDNIconUrl('generic_16x16'),
};

/**
 * Get icon CSS for attachment
 */
export function getIconCSSForAttachment(
    fileName: string,
    contentType: string,
    isBlocked: boolean,
    isFolder: boolean,
    embeddedItemClass: string
): FileIcon {
    if (isBlocked) {
        return blockedFileIcon;
    }

    switch (embeddedItemClass) {
        case 'IPM.Note': // Email
        case 'IPM.Note.SMIME': // Smime Item Attachment
        case 'IPM.Note.SMIME.MultipartSigned': // Smime Clear Signed Item Attachment
            return msgFileIcon;
        case 'IPM.Schedule': // Calendar Item
        case 'IPM.Appointment': // Calendar Item
        case 'IPM.OLE.CLASS.{00061055-0000-0000-C000-000000000046}': // Meeting recurrence exception
            return calendarFileIcon;
        default:
            break;
    }

    // isFolder is undefined for reference attachments
    // VSO - 17242 Add attachmentsIsFolder property to the files folder for reference attachments
    // folders are treated differently for attachments compared to the rest of the product, so they
    // are handled here instead of in getIconForFile.
    if (!!isFolder) {
        return sharedFolderIcon;
    }

    const fileIcon = getIconForFile(fileName, false /*isFolder */, contentType);

    // Show generic file icons if we could not map the file to any type
    return fileIcon || genericFileIcon;
}
